import React from "react";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import { useOutletContext } from "react-router";
import { PageWrapper } from "components/Containers";
import { Grid } from "components/Containers";
import PageTitle from "components/PageTitle";
import { MissionAboutClient } from "components/Missions";
import { RelatedRoles, RoleDetails } from "components/Missions/Roles";
import { useAuth } from "hooks";
import Card from "components/Card";
import { NotesInputBox, NotesList } from "components/Notes";
import { COMMENTABLE_TYPES } from "constants/index";

/**
 * Mission Role Discussions
 */
const MissionRoleDiscussions = () => {
  const { canViewUnpublishedRoles, ...me } = useAuth();
  const { selectedRole, mission, loading } = useOutletContext();
  const resultsPerPage = 20;
  const intl = useIntl();

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Missions.Role.Discussions.Title" })}</title>
      </Helmet>
      <PageWrapper>
        <Grid>
          <Grid.col start={1} end={13}>
            <PageTitle subtitle={<FormattedMessage id="Missions.Roles.Discussions.Title" />} />
          </Grid.col>
          <Grid.col start={1} end={9}>
            <Grid>
              <Grid.col start={1} end={13}>
                <Card>
                  <NotesInputBox
                    user={me}
                    commentableId={selectedRole?.id}
                    commentableType={COMMENTABLE_TYPES.missionRole}
                    resultsPerPage={resultsPerPage}
                    placeholder={<FormattedMessage id="Profile.Notes.Placeholder" />}
                  />
                </Card>
              </Grid.col>
              <Grid.col start={1} end={13}>
                <NotesList
                  user={me}
                  commentableId={selectedRole?.id}
                  commentableType={COMMENTABLE_TYPES.missionRole}
                  resultsPerPage={resultsPerPage}
                />
              </Grid.col>
            </Grid>
          </Grid.col>
          <Grid.col start={9} end={13}>
            <Grid>
              <Grid.col start={1} end={13}>
                <Card>
                  <RoleDetails role={selectedRole} mission={mission} loading={loading} />
                </Card>
              </Grid.col>
              <Grid.col start={1} end={13}>
                <Card>
                  <RelatedRoles
                    missionId={mission?.uuid}
                    isLoading={loading}
                    canViewUnpublishedRoles={canViewUnpublishedRoles}
                  />
                </Card>
              </Grid.col>
              <Grid.col start={1} end={13}>
                <Card>
                  <MissionAboutClient mission={mission} isLoading={loading} />
                </Card>
              </Grid.col>
            </Grid>
          </Grid.col>
        </Grid>
      </PageWrapper>
    </>
  );
};

export default MissionRoleDiscussions;
